<template>
    <div>



<!-- <app-monev_topbar></app-monev_topbar>
<app-monev_left_sidebar></app-monev_left_sidebar> -->

<section class="content">
<div class="container-fluid">

       <div class="row clearfix">

            <div class="bg-light-green" style="margin-top:-1% !important;">
                <!-- <br> -->
                <div class="row paddingku">
                    <div class="col-md-3 searching">
                        <span class="h_page">Data Wilayah</span> <br> <br>
                    </div>
                    <div class="col-md-6">

                    </div>
                    <div class="col-md-3 searching">
                        <div class="input-group">
                            <span class="input-group-btn">
                                <button type="button" class="btn bg-light-blue btn-sm waves-effect" data-toggle="modal" data-target="#m_tambah_data"><i class="material-icons" title="Tambah Data">add</i></button>
                            </span>
                            <input type="text" class="form-control" placeholder="Cari data" id="caridata" @keyup="cari_data" v-model="cari_value">
                        </div> <br>
                    </div>
                </div>
            </div>


            <div class="col-xs-12 card">
        <!-- ============================================================ MULAI ======================================================================== -->
                <br>
                <div class="table-responsive">
                    <table class="table table-bordered" style="width: 100%">
                        <thead>
                        <tr class="bg-info">
                            <th class="text-center" style="width: 5%">No.</th>
                            <th class="text-center" style="width: 10%">Kode</th>
                            <th style="width: 70%">Wilayah</th>
                            <th style="width: 15%">#</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr class="h_isitable" v-for="(data, index) in list_wilayah" track-by="data.date" :key="data._id">
                            <td class="text-center">{{ index +1}}.</td>
                             <td class="text-center">{{data.kd_propinsi}}</td>
                            <td>{{data.nm_propinsi}}</td>
                            <td class="text-center" >
                                    <!-- <button type="button" class="btn bg-blue btn-xs waves-effect" id="lihat_dokumen">
                                        <i class="material-icons" >search</i>
                                    </button> -->

                                    <button @click="getEdit(data.id, data.kd_propinsi, data.nm_propinsi, data.createdtime)" class="btn bg-light-green btn-xs waves-effect" title="Edit Data" id="edit_data" data-toggle="modal" data-target="#m_edit_data">
                                        <i class="material-icons" >create</i>
                                    </button>
                                    &nbsp;
                                    <button @click="removeWilayah(data.kd_propinsi)" class="btn bg-red btn-xs waves-effect" title="Hapus Data" id="hapus_data">
                                        <i class="material-icons" >clear</i>
                                    </button>
                            </td>
                        </tr>

                        </tbody>
                    </table>
                </div>

                <!-- <button @click="ceksaja">CEK</button> -->
                <!-- <h1>INI</h1>


                <input type="text" class="form-control" placeholder="Pilih Instansi1" id="instansi">
                <input type="text" class="form-control" placeholder="Pilih Instansi" id="id_instansi" >
                <input type="text" class="form-control" placeholder="Pilih Instansi" id="id_ins">


                <h1>INI</h1> -->


                <hr>
                  <div class="text-center">
                      <button @click="btn_prev" type="button" class="btn btn-xs bg-blue waves-effect" id="pref">
                              <i class="material-icons">skip_previous</i>
                      </button>
                       &nbsp;
                      <span style="font-size: 85%; color: #a5a5a5"><b>{{page_first}} - {{page_last}}</b></span>
                       &nbsp;
                      <button @click="btn_next" type="button" class="btn btn-xs bg-blue waves-effect" id="next">
                              <i class="material-icons">skip_next</i>
                      </button>
                  </div>
                <hr>

        <!-- ============================================================ MODAL ======================================================================== -->
            <div class="modal fade" id="m_tambah_data" tabindex="-1" role="dialog">
                <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header bg-light-blue">
                            <h4 class="modal-title" id="largeModalLabel">TAMBAH DATA</h4>
                        </div>
                          <form @submit.prevent="addWilayah()">
                            <div class="modal-body">
                                <div class="row clearfix">
                                    <div class="col-md-2 form-control-label">
                                        <label for="kode">Kode Wilayah</label>
                                    </div>
                                    <div class="col-md-10">
                                        <div class="form-group">
                                            <div class="form-line">
                                                <input v-model="dataku.kd_propinsi" type="text" id="nilai" class="form-control" placeholder="Ex : 01">
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row clearfix">
                                    <div class="col-md-2 form-control-label">
                                        <label for="kode">Nama Wilayah</label>
                                    </div>
                                    <div class="col-md-10">
                                        <div class="form-group">
                                            <div class="form-line">
                                                <input v-model="dataku.nm_propinsi" type="text" id="nilai" class="form-control" placeholder="Ex : Sulawesi Tenggara">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="submit" class="btn btn-info waves-effect">SIMPAN</button>
                                <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                            </div>
                          </form>
                    </div>
                </div>
            </div>
          <!-- </div> -->

            <div class="modal fade" id="m_edit_data" tabindex="-1" role="dialog">
                <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header bg-light-green">
                            <h4 class="modal-title" id="largeModalLabel">EDIT DATA</h4>
                        </div>
                        <div class="modal-body">

                            <!-- <div class="row clearfix">
                                <div class="col-md-2 form-control-label">
                                    <label for="kode">Kode Wilayah</label>
                                </div>
                                <div class="col-md-10">
                                    <div class="form-group">
                                        <div class="form-line">
                                            <input v-model="dataku.kd_propinsi" type="text" id="nilai" class="form-control" placeholder="Ex : 01">
                                        </div>
                                    </div>
                                </div>
                            </div>
                         -->
                          <div class="row clearfix">
                              <div class="col-md-2 form-control-label">
                                  <label for="kode">Nama Wilayah</label>
                              </div>
                              <div class="col-md-10">
                                  <div class="form-group">
                                      <div class="form-line">
                                          <input type="text" id="nilai" class="form-control" placeholder="Ex : Sulawesi Tenggara" v-model="dataku.nm_propinsi">
                                      </div>
                                  </div>
                              </div>
                          </div>
                        </div>
                        <div class="modal-footer">
                            <button @click="editWilayah" type="button" class="btn btn-success waves-effect">RUBAH</button>
                            <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                        </div>
                    </div>
                </div>
            </div>
        <!-- ============================================================ MODAL ======================================================================== -->

        <!-- ============================================================ MULAI ======================================================================== -->
        </div>
      </div>

        </div>
      </section>
  </div>




</template>


<script>

// import Autocomplete from 'vue2-autocomplete-js'

const ADD_URL = 'http://localhost:5000/api/v1/bhumie_provinsi/';

    export default {
      // components: { Autocomplete },
        name: 'monev_wilayah',
            data () {
            return {
                dataku: {
                  id : '',
                  kd_propinsi : '',
                  nm_propinsi : '',
                  createdtime : '',
                  id : '',
                },
                list_wilayah : [],
                page_first : 1,
                page_last : 0,
                cari_value : '',
            }
        },

        mounted : function(){
          this.getWilayah();
          this.autocompleted();
        },

        methods : {
          cek_index : function(){
            alert('aaaa');
          },

          getWilayah : function(){

            fetch(ADD_URL+'view', {
              method : 'POST',
              headers : {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
              },
              body : JSON.stringify({
                data_ke : this.page_first,
                cari_value : this.cari_value

              })
            }).then((res) => res.json())
              .then ((res_wilayah) => {
                this.list_wilayah = res_wilayah.data;
                this.page_last = res_wilayah.jml_data
                console.log(res_wilayah);
              })

          },

          addWilayah : function(){
            fetch (ADD_URL+'add', {
              method : 'POST',
              headers : {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
              },
              body : JSON.stringify(this.dataku)
            }).then(res => res.json())
              .then((res_wilayah) => {
                // this.list_wilayah.unshift(res_wilayah);
                // console.log(res_wilayah);
                this.getWilayah();
                this.alertku('success', 'sukses menambah data')
              })
          },


          removeWilayah : function(kd_propinsi){
            fetch(ADD_URL+'remove', {
              method : 'POST',
              headers : {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
              },
              body : JSON.stringify({kd_propinsi : kd_propinsi})
            }).then((res_wilayah)=>{
              this.getWilayah();
              this.alertku('success', 'sukses menghapus data')
            })
          },

          editWilayah : function(){
            fetch (ADD_URL+'update', {
              method : 'POST',
              headers : {
                'content-type' : 'application/json',
                authorization : 'kikensbatara '+localStorage.token,
              },
              body : JSON.stringify(this.dataku)
            }).then((res_wilayah)=>{
              this.getWilayah();
              this.alertku('success', 'sukses merubah data')
            })
          },

          getEdit : function(id, kd_propinsi, nm_propinsi, createdtime){
            this.dataku.id = id;  
            this.dataku.kd_propinsi = kd_propinsi;
            this.dataku.nm_propinsi = nm_propinsi;
            this.dataku.createdtime = createdtime;
          },

          autocompleted : function(){

            $.ajax({
              url: URL_APP+'api/v1/program/',
              type: "GET",
              headers : {
                'content-type' : 'application/json',
                authorization : 'kikensbatara '+localStorage.token,
              },
              success: function(result){
                horsey(document.querySelector('#instansi'), {
                  source: [{ list: result }],
                  getText: 'uraian',
                  getValue: 'uraian',
                  predictNextSearch(info) {
                    document.getElementById('id_instansi').value= info.selection._id ;
                    document.getElementById('id_ins').value= info.selection.uraian ;
                  },
                  limit: 2
                });
            }});

          },



          // ================== PAGINASI ====================
            alertku : function(type, title){
              this.$swal({
                type: type,
                title: title,
                showConfirmButton: false,
                timer: 800
              });
            },

            btn_prev : function(){
              if(this.page_first>1){
                this.page_first--
              }else{
                this.page_first = 1;
              }
              this.getWilayah();
            },

            btn_next : function(){
              if(this.page_first >= this.page_last){
                this.page_first == this.page_last
              }else{
                this.page_first++;
              }
              this.getWilayah();
            },

            cari_data : function(){
              this.getWilayah();
            },

          // ================== PAGINASI ====================
        },

    }
</script>
